import { render, staticRenderFns } from "./HotelList.vue?vue&type=template&id=5a110f3b"
import script from "./HotelList.vue?vue&type=script&lang=js"
export * from "./HotelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports